/**
 * Cryptographically secure random helpers (SonarLint: avoid Math.random()).
 */

/** Random float in [0, 1) using crypto.getRandomValues */
export function secureRandom(): number {
  const buffer = new Uint32Array(1);
  crypto.getRandomValues(buffer);
  return buffer[0] / (0xffffffff + 1);
}

/** Random integer in [0, max) */
export function secureRandomInt(max: number): number {
  if (max <= 0) {
    return 0;
  }
  return Math.floor(secureRandom() * max);
}

/** Random alphanumeric string (URL-safe subset) */
export function secureRandomString(length = 9): string {
  return crypto.randomUUID().replace(/-/g, "").slice(0, length);
}

/** Correlation / trace id for logs and requests */
export function createCorrelationId(prefix = "corr"): string {
  return `${prefix}-${Date.now()}-${secureRandomString(8)}`;
}

/** Pick a random element from a non-empty array */
export function securePick<T>(items: readonly T[]): T {
  return items[secureRandomInt(items.length)];
}
